import React from "react";
import { Row, Col } from "antd";
import PlantillaCard from "./PlantillaCard";
import FormatoAceptacionPlanCompra from "./FormatoAceptacionCompras";
import FormatoDelegacionPlanCompra from "../FormatoDelegacionFirmaPlanCompra/FormatoDelegacionFirmaPlanCompraPDF";

const ListaDePlantillas = ({ idCurrentPlan, updateData}) => {
  return (
    <div style={{ padding: "24px" }}>
      <Row gutter={[24, 24]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <PlantillaCard
            titulo="Formato de Aceptación"
            ComponenteEdicion={FormatoAceptacionPlanCompra}
            parametro={idCurrentPlan}
            tipo_formato={1}
            updateData={updateData}
          />
        </Col>

        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <PlantillaCard
            titulo="Formato de delegación"
            ComponenteEdicion={FormatoDelegacionPlanCompra}
            parametro={idCurrentPlan}
            tipo_formato={2}
            updateData={updateData}
         
          />
        </Col>
      </Row>
    </div>
  );
};

export default ListaDePlantillas;
